import gql from "graphql-tag";

export const hasManageWorkSchedulesAccessQuery = gql`
  query hasManageWorkSchedulesAccess {
    hasManageWorkSchedulesAccess
  }
`;
